(function(){
    angular
        .module('app')
        .directive('capitalize', capitalize);

        capitalize.$inject = ['$timeout'];
        function capitalize($timeout){
            return {
	            require: 'ngModel',
	            link: function(scope, element, attrs, modelCtrl) {
					var capitalize = function(inputValue) {
					
					//var capitalized = !!String(inputValue).match(/^[a-z]*$/i);

			        if (inputValue == undefined) inputValue = ''; 	
			          	
			        if (inputValue !="") {
			            // see where the cursor is before the update so that we can set it back
			            var capitalized = inputValue[0].toUpperCase()+ inputValue.substr(1).toLowerCase();
			            var selection = element[0].selectionStart;
			            modelCtrl.$setViewValue(capitalized);
			            modelCtrl.$render();
			            // set back the cursor after rendering
			            element[0].selectionStart = selection;
			            element[0].selectionEnd = selection;
			          }
			          return capitalized;
			        }
			        modelCtrl.$parsers.push(capitalize);
			        capitalize(scope[attrs.ngModel]); // capitalize initial value
				}
        	}
        }


        angular
        .module('app')
        .directive("ngFileSelect",function($q){
       	  var slice = Array.prototype.slice;

		  return {
            require: 'ngModel',
		    link: function(scope, element, attrs, ngModel) {
		      	
		      	 element.bind('change', function(e) {
			          var element = e.target;

			          $q.all(slice.call(element.files, 0).map(readFile))
			            .then(function(values) {
			              if (element.multiple) ngModel.$setViewValue(values);
			              else ngModel.$setViewValue(values.length ? values[0] : null);
			            });

			          function readFile(file) {
			            var deferred = $q.defer();

			            var reader = new FileReader();
			            reader.onload = function(e) {
			              deferred.resolve(e.target.result);
			              if (scope.onCompleted)
			                scope.onCompleted(e.target.result, scope);
			            };
			            reader.onerror = function(e) {
			              deferred.reject(e);
			              if (scope.onError)
			                scope.onError(e, scope);
			            };
			            reader.readAsText(file);
			            return deferred.promise;
			          }
        		}); 
		   		
		      
		    }
		    
		  }
		});
  
})();